import flatpickr from "flatpickr"
import { Japanese } from "flatpickr/dist/l10n/ja.js"
import MicroModal from 'micromodal';

// 登録車両一覧
$(function() {
  var headerHight = $('.header').innerHeight();
  if($('.vehicle-info__item').length > 1) {
    $('.open-vehicle-info__wrap').show();
  }
  /**
   * 登録車両一覧のボタン押下時
   */
  $('.open-vehicle-info').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('.vehicle-info__link-list').html('');
      let item = $('.vehicle-info__item').length;
      for(let $i = 0; $i < item; $i++) {
        let carName = $($('.vehicle-info__item').get($i)).find('input.vehicle-name').val();
        let listItem = '<li class="vehicle-info__link-item button"><a href="#item-' + $i +'" class="vehicle-info__link-item__button"><span>'+ carName +'</span></a></li>';
        // 車両名のinputに入力しているものだけモーダルに追加
        if(carName) {
          $('.vehicle-info__link-list').append(listItem);
        }
      }
      MicroModal.show('modal-vehicle-info', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
      $('a[href^="#"]').on("click", function (event) {
        event.preventDefault();
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
        $("html, body").animate({ scrollTop: position }, 500, "swing");
        // aタグクリック後にモーダルを閉じる
        MicroModal.close('modal-vehicle-info');
        return false;
      });
    }
  });
  /**
   * 「この車両情報を削除する」ボタン
   */
  if($('.vehicle-info').length) {
    // 車両情報それぞれで使用する数字を書き換えfunction
    function itemAttr() {
      var $i = 0;
      $('.vehicle-info__item').each(function() {
        $(this).attr('id', 'item-' + $i);
        $i++;
        $(this).find('label.custom-file-label').attr('for', 'VehicleInspectionCertificate'+$i);
        // 車検証写しの取り消しボタン
        $(this).find('.input-group-append').attr('data-id', $i);
        $(this).find('.input-group-append button').attr('data-id', $i);
        $(this).find('.imagePreview').attr('id', 'preview_'+$i);
        $(this).find('.form-control.readonly').attr('id', 'readonly_file'+$i);
        $(this).find('.delete-btn').attr('id', 'delete_file'+$i);
        $(this).find('input[name="upload_image_path[]"]').data('id', $i);
      });
    }
    /**
     * 車両写真選択
     */
    $(document).on('change', 'input[name^="upload_"]', function () {
      let input = $(this),
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.parent().parent().next(':text').val(label);
      let name = input.attr('name');
      let target = name.replace("upload_", "").replace("[]", "");
      let iDataId = input.data('id');
      let files = !!this.files ? this.files : [];
      if (!files.length || !window.FileReader)
        return; // no file selected, or no FileReader support
      if (/^image/.test(files[0].type)) { // only image file
        var reader = new FileReader(); // instance of the FileReader
        reader.readAsDataURL(files[0]); // read the local file
        reader.onloadend = function () { // set image data as background of div
          $('#preview_' + iDataId).empty();
          var img = $('<img src="' + this.result + '">');
          $('#preview_' + iDataId).append(img);
          img.ready(function() {
            $('#' + iDataId).val(label);
          });
        }
      } else {
        var readerB = new FileReader(); // instance of the FileReader
        readerB.readAsDataURL(files[0]); // read the local file
        readerB.onloadend = function () { // set image data as background of div
          $('#preview_' + iDataId).empty();
          $('#preview_' + iDataId).append('<img src="'+ location.protocol+ '//' + location.host + '/admin/img/pdf.png">');
          $('#' + iDataId).val(label);
        }
      }
    });
    /**
     * 削除ボタンを押下時
     */
    $(document).on(oEventNames.end, '.js-delete-vehicle-info-btn', function (event) {
      if($('.vehicle-info__item').length > 1 ) {
        var deleteConfirm = confirm('削除してよろしいでしょうか？');
        if(deleteConfirm == true) {
          if (!bIsScrolling) {
            event.preventDefault();
            // 論理削除するIDの<input type="hidden">を用意
            let iDeleteId = $(this).closest('.vehicle-info__item').find('input[name="id[]"]').val();
            $(this).closest('form').append('<input type="hidden" name="delete_id[]" value="' + iDeleteId + '">');
            $(this).closest('.vehicle-info__item').remove();
            itemAttr();
          }
        }
        // 車両情報が20件になったら追加ボタンを非表示
        if($('.vehicle-info__item').length == 20) {
          $('.add-vehicle-info-btn').fadeOut();
        }else{
          $('.add-vehicle-info-btn').fadeIn();
        }
      }
    });
    /**
     * ファイル削除
     */
    $(document).on('click', '.fileup-box .delete-btn', function () {
      var id = $(this).attr('id');
      var target = id.replace("delete_", "");
      $(this).closest('.fileup-box').find('.form-control').val('');
      clone.ready(function() {
        $('*[name=' + target + ']').val('');
        $('#readonly_' + target).val('');
      });
      $('#preview_' + target).empty();
      $('#preview_' + target).append('<img src="/admin/img/no_photo.jpg">');
    });
    /**
     * 車両情報を1件追加
     */
    $(document).on(oEventNames.end, '.js-add-vehicle-info-btn', function (event) {
      if (!bIsScrolling) {
        if($('.vehicle-info__item').length < 20) {
          event.preventDefault();
          var clone = $(this).parent().prev('ul#js-item-list').find('.vehicle-info__item:last-of-type').clone(true);
          // inputなどの要素を空に
          clone.find('input[name="id[]"]').val('');
          clone.find("input[type='text']").val("");
          clone.find('.custom-file input[type="file"]').val("");
          clone.find('.custom-file input[type="file"]').attr('required', true);
          clone.find('.custom-file-label').removeClass("selected");
          clone.find('.custom-file-label').text("ファイル選択...");
          clone.find(".fileup-box input").val("");
          clone.find(".form-group__content .imagePreview img").attr('src', location.protocol + '//' + location.host + '/admin/img/no_photo.jpg' );
          clone.find('input[name="upload_image_path[]"]').attr('required', true);
          clone.find(".not-clone").remove();

          clone.appendTo('#js-item-list');
          flatpickr('.flatpickr', {
            "locale": Japanese, // このインスタンスのみの言語指定
            disableMobile: "true"
          });
          itemAttr();
        }
        // 車両情報が20件になったら追加ボタンを非表示
        if($('.vehicle-info__item').length == 20) {
          $('.add-vehicle-info-btn').fadeOut();
        }else{
          $('.add-vehicle-info-btn').fadeIn();
        }
      };
        if($('.vehicle-info__item').length > 1) {
          $('.open-vehicle-info__wrap').fadeIn();
        }
    });
  }
});
